import { Delete, Edit } from "@mui/icons-material";
import { IconButton, Tooltip } from "@mui/material";
import moment from "moment";
import { InputSwitch } from "primereact/inputswitch";
import React, { Fragment, useContext } from "react";
import { TIME_ZONE } from "../../../../constants";
import { useMutation } from "react-query";
import { IsLoadingResponse } from "../../../../utils/Helper";
import DataTabel from "../../../../reuseable/DataTabel";
import { TABEL_UNIQUE_ID } from "../../../../constants/RoutingConstants/RoutingConstants";
import SweetConfirmation from "../../../../reuseable/sweetConfirmation";
import FeatureContext from "../../../../context/FeatureContext/FeatureContext";
import {
  Delete_Feature,
  Enable_Disable_Feature,
  Get_Details_Feature,
} from "../../../../Apis/featureApi/FeatureApi";

const FeatureDataTabelContainer = (props) => {
  const {
    filter,
    setFilter,
    record,
    pageSize,
    page,
    setPageSize,
    setPage,
    setFormData,
    setdialogs,
    setId,
    setIsEdit,
    setSortBy,
    setSortOrder,
    sortOrder,
  } = useContext(FeatureContext);
  const { isLoading, data, handleOpenandClosePopup, refetch } = props;

  /**
   * get feature Details
   */
  const { mutate: featureDetails, isLoading: isLoadingFeatureDetails } =
    useMutation((featureId) =>
      Get_Details_Feature(featureId, setFormData, setdialogs)
    );

  const GetUserDetails = (featureId) => {
    featureDetails(featureId);
    setId(featureId);
    setIsEdit(false);
  };

  /**
   * delete feature
   */
  const { mutate: featureDelete, isLoading: isLoadingDelete } = useMutation(
    (featureId) => Delete_Feature(featureId, refetch)
  );

  const DeleteFeature = async (featureId) => {
    let { isConfirmed } = await SweetConfirmation();
    if (isConfirmed) {
      featureDelete(featureId);
    }
  };

  /**
   * enable / disable feature
   */

  const { mutate: statusChangeMutate } = useMutation((formData) =>
    Enable_Disable_Feature(formData, refetch)
  );

  const handleFeatureStatusChange = (featureId, status) => {
    let formDate = {
      featureId: featureId,
      isActive: status ? false : true,
    };

    data.payload.data = data.payload.data.map((row) => {
      if (row.featureId === featureId) {
        return {
          ...row,
          isActive: status ? false : true,
        };
      } else {
        return row;
      }
    });
    statusChangeMutate(formDate);
  };

  /**
   *
   * @param {Sorting obj} col
   * Table Sorting
   */

  const sorting = (col) => {
    if (sortOrder === "") {
      let found = col.find((obj) => {
        return obj.field;
      });
      setSortBy(found.field);
      setSortOrder("ASC");
    }
    if (sortOrder === "ASC") {
      let found = col.find((obj) => {
        return obj.field;
      });
      setSortBy(found.field);
      setSortOrder("DSC");
    }
    if (sortOrder === "DSC") {
      setSortBy();
      setSortOrder("");
    }
  };

  const defaultColumns = [
    {
      flex: 0.1,
      minWidth: 180,
      field: "logo",
      headerName: "Image",
      sortable: false,
      filterable: false,
      disableColumnMenu: true,
      renderCell: (params) => (
        <input
          type="image"
          img="true"
          src={
            params.row.imageUrl
              ? params.row.imageUrl
              : require("../../../../assets/Images/ImageNotFound.png")
          }
          alt="photo"
          style={{ height: "2rem" }}
        />
      ),
    },
    {
      flex: 0.1,
      minWidth: 250,
      field: "title",
      headerName: "Title",
      renderCell: (params) => (params.row.title ? params.row.title : "--"),
    },
    {
      flex: 0.1,
      minWidth: 180,
      field: "subTitle",
      headerName: "Sub Title",
      renderCell: (params) =>
        params.row.subTitle ? params.row.subTitle : "--",
    },
    {
      flex: 0.1,
      minWidth: 100,
      field: "status",
      headerName: "Status",
      renderCell: (params, index) => (
        <div className="flex justify-content-center">
          <InputSwitch
            checked={params.row.isActive === true}
            onChange={() =>
              handleFeatureStatusChange(
                params.row.featureId,
                params.row.isActive
              )
            }
          />
        </div>
      ),
    },
    {
      flex: 0.1,
      minWidth: 180,
      field: "createdAt",
      headerName: "CreatedAt",
      sortable: false,
      renderCell: (params) =>
        moment(params.row.createdAt)
          .utcOffset(TIME_ZONE)
          .format("DD MMM, YYYY hh:mm"),
    },
    {
      flex: 0.1,
      minWidth: 100,
      field: "actions",
      headerName: "Actions",
      sortable: false,

      renderCell: (params) => (
        <>
          <div style={{ paddingRight: "5px" }}>
            <Tooltip title="Edit">
              <IconButton
                aria-label="edit"
                onClick={() => GetUserDetails(params.row.featureId)}
              >
                <Edit style={{ color: "#7366ff" }} />
              </IconButton>
            </Tooltip>
          </div>
          <div style={{ paddingRight: "5px" }}>
            <Tooltip title="Delete">
              <IconButton
                aria-label="delete"
                onClick={() => DeleteFeature(params.row.featureId)}
              >
                <Delete style={{ color: "red" }} />
              </IconButton>
            </Tooltip>
          </div>
        </>
      ),
    },
  ];
  return (
    <Fragment>
      <IsLoadingResponse
        isLoading={isLoadingFeatureDetails || isLoadingDelete}
      />
      <DataTabel
        filter={filter}
        setFilter={setFilter}
        handleOpenandClosePopup={handleOpenandClosePopup}
        data={data}
        defaultColumns={defaultColumns}
        record={record}
        pageSize={pageSize}
        page={page}
        setPageSize={setPageSize}
        setPage={setPage}
        sorting={sorting}
        isLoading={isLoading}
        sortOrder={sortOrder}
        setSortBy={setSortBy}
        setSortOrder={setSortOrder}
        id={TABEL_UNIQUE_ID.featureId}
        addButton={true}
      />
    </Fragment>
  );
};

export default FeatureDataTabelContainer;
